import React, { Component } from 'react';
import { useTranslation } from 'react-i18next';

import { withFirebase } from '../Firebase';

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  submitting: false,
  error: null,
};

const withTranslation = (Component) => {
  return (props) => {
    const { t } = useTranslation();
    return <Component {...props} t={t} />;
  };
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    event.preventDefault();
    if (this.state.submitting) return;
    const { passwordOne } = this.state;

    this.setState({ submitting: true, error: null });

    this.props.firebase
      .doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        this.setState({ error });
      })
      .finally(() => {
        this.setState(prevState => (
          prevState.submitting ? { submitting: false } : null
        ));
      });
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { passwordOne, passwordTwo, submitting, error } = this.state;
    const { t } = this.props;

    const isInvalid =
      passwordOne !== passwordTwo || passwordOne === '';

    return (
      <form onSubmit={this.onSubmit}>
        {error && (
            <p>{error.message}</p>
        )}
        <div>
          <fieldset>
            <label>{t('passwordChange.old_password_label')}</label>
            <input
              name="passwordOne"
              value={passwordOne}
              onChange={this.onChange}
              type="password"
              placeholder={t('passwordChange.new_password_placeholder')}
            />
          </fieldset>
          <fieldset>
            <label>{t('passwordChange.new_password_label')}</label>
            <input
              name="passwordTwo"
              value={passwordTwo}
              onChange={this.onChange}
              type="password"
              placeholder={t('passwordChange.confirm_password_placeholder')}
            />
          </fieldset>
        </div>
        <button className={'primary' + (submitting ? ' btn-loading' : '')} disabled={isInvalid || submitting} type="submit">
          {t('passwordChange.submit_button')}
        </button>
      </form>
    );
  }
}

export default withTranslation(withFirebase(PasswordChangeForm));
